import React from 'react';

import { MRT_ColumnDef, amountToAccessorValue } from 'components/MRT';
import { ImpactCost, InfoTooltip, TokenName } from 'components';
import { SystemStyleObject, styled } from 'core/styles';
import { dumpCostInfo, pumpCostInfo } from 'domain/utils';

import { CostsTableData } from '../../types';

const headCellAlignStyles: SystemStyleObject = {
  '& .Mui-TableHeadCell-Content': {
    justifyContent: 'flex-end',
  },
};

const numberFilters = ['greaterThan', 'lessThan', 'between'];

export const impactCostsTableColumns: MRT_ColumnDef<CostsTableData>[] = [
  {
    header: 'Asset',
    accessorFn: originalRow => originalRow.token.symbol,
    id: 'asset',
    columnFilterModeOptions: ['fuzzy', 'contains', 'startsWith', 'endsWith'],
    minSize: 100,
    maxSize: 200,
    enableColumnActions: false,
    Cell: ({ row, renderedCellValue }) => (
      <TokenName token={row.original.token} symbol={renderedCellValue} />
    ),
  },
  {
    header: '',
    Header: () => (
      <HeaderBox>
        <InfoTooltip title={pumpCostInfo} />
        <span>Pump Cost</span>
      </HeaderBox>
    ),
    accessorFn: originalRow => amountToAccessorValue(originalRow.pumpCost),
    id: 'pumpCost',
    columnFilterModeOptions: numberFilters,
    filterFn: numberFilters[0],
    sortingFn: 'basic',
    minSize: 100,
    maxSize: 120,
    enableColumnActions: false,
    Cell: ({ row }) => (
      <ImpactCost reserveTagSpace cost={row.original.pumpCost} model={row.original.pumpCostModel} />
    ),
    muiTableHeadCellProps: {
      sx: headCellAlignStyles,
    },
    muiTableBodyCellProps: {
      align: 'right',
    },
  },
  {
    header: '',
    Header: () => (
      <HeaderBox>
        <InfoTooltip title={dumpCostInfo} />
        <span>Dump Cost</span>
      </HeaderBox>
    ),
    accessorFn: originalRow => amountToAccessorValue(originalRow.dumpCost),
    id: 'dumpCost',
    columnFilterModeOptions: numberFilters,
    filterFn: 'greaterThan',
    sortingFn: 'basic',
    minSize: 110,
    maxSize: 130,
    enableColumnActions: false,
    Cell: ({ row }) => (
      <ImpactCost reserveTagSpace cost={row.original.dumpCost} model={row.original.dumpCostModel} />
    ),
    muiTableHeadCellProps: {
      sx: headCellAlignStyles,
    },
    muiTableBodyCellProps: {
      align: 'right',
    },
  },
];

const HeaderBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});
